import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { EfficiencyAnalysisComponent } from './efficiency-analysis.component';

const routes: Routes = [
  {
    path: '',
    component: EfficiencyAnalysisComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class EfficiencyAnalysisRoutingModule {}
